import React, {useEffect, useState} from 'react';

import './StaffMng.css';
import Http from 'Utils/Axios';
import Layout from 'layouts/Default/Default';
import StaffMngListForm from "./StaffMngList/StaffMngListForm";
import StaffMngAddForm from "./StaffMngAdd/StaffMngAddForm";
import StaffShift from "../StaffShift/StaffShift";
import {fncgGetUserLoginCheck, fncgGetDbconn} from "Utils/Common/ComCom";
import {DISP_FG, PRM_ID, SEARCH_ID} from "../../../Utils/Common/ComConst";
import {useLocation} from "react-router-dom";

let dispFlg = '0';

function StaffMng({ match, history, location }) {
	const [shop, setShop] = useState('');
	const [data, setData] = useState('');
	const [disp, setDisp] = useState('0');
	const [user, setUser] = useState('');
	const [urlpram, setUrlPram] = useState('');
	const [dbconn, setDbConn] = useState('');
	const [start, setStart] = useState('0');
	const path = useLocation().pathname;
	const handleSetUser = userData => setUser(userData);
	const handleSetUrlPram = dat => setUrlPram(dat);
	const handleSetDbConn = dat => setDbConn(dat);
	const handleSetStart = dat => setStart(dat);

	/**
	 * 初期処理
	 */
	useEffect(() => {
		//-- 画面情報
		const dispFg = localStorage.getItem(DISP_FG);
		if(dispFg != '' && dispFg != undefined){
			dispFlg = dispFg;
		}else{
			dispFlg = '0';
		}
		let searchID = localStorage.getItem(SEARCH_ID);
		if(searchID != '' && searchID != undefined){
			searchID = JSON.parse(searchID);
			setData(searchID);
		}

		fncgGetDbconn({history, location, handleSetUrlPram, handleSetDbConn, handleSetStart});
	}, [])

	/**
	 * スタッフ情報取得
	 */
	useEffect(() => {
		if(start == '0') return;
		// ログインチェックを行いユーザ情報を返却する
		fncgGetUserLoginCheck({dbconn, urlpram, path, user, handleSetUser, history})
	}, [start])

	/**
	 * 店舗情報取得
	 */
	useEffect(() => {
		if(start == '0' && dbconn.id == '' || dbconn.id == undefined) return;
		let aryData = {id : dbconn.id};
		Http.post('api/get-shop',{...aryData}).then(response => {
			setShop(response.data.Shop);
		});
	}, [start])

	/**
	 * 新規登録
	 * @param data
	 */
	const onSubmitMoveAddDisp = data => {
		if(data.mode != '4'){
			setDisp('1');
			dispFlg = '1';
			localStorage.setItem(DISP_FG, '1');
		}else{
			setDisp('2');
			dispFlg = '2';
			localStorage.setItem(DISP_FG, '2');
		}
		data.id = dbconn.id;
		setData(data);
		window.scrollTo(0, 0);
	}

	/**
	 * 一覧画面表示
	 * @param data
	 */
	const onSubmitMoveListDisp = data => {
		data.id = dbconn.id;
		dispFlg = '0';
		setDisp('0');
		setData(data);
		localStorage.setItem(DISP_FG, '0');
		window.scrollTo(0, 0);
	}

	return (
		<>
			{(dispFlg == '0' && shop != "" && shop != undefined && user != "" && user != undefined) &&(
				<Layout headerText="スタッフ管理 -スタッフ一覧-" _dbconn={dbconn} _user={user}>
					<StaffMngListForm
						history={history}
						user={user}
						dbconn={dbconn}
						submitMove={onSubmitMoveAddDisp}
					/>
				</Layout >
			)}

			{(dispFlg == '1' && shop != "" && shop != undefined && user != "" && user != undefined) &&(
				<Layout headerText="スタッフ管理 -スタッフ登録-" _dbconn={dbconn} _user={user}>
					<StaffMngAddForm
						history={history}
						user={user}
						shop={shop}
						data={data}
						dbconn={dbconn}
						submitReturn={onSubmitMoveListDisp}
					/>
				</Layout>
			)}

			{(dispFlg == '2' && shop != "" && shop != undefined  && user != "" && user != undefined) &&(
				<>
					<StaffShift
						history={history}
						user={user}
						shop={shop}
						data={data}
						dbconn={dbconn}
						submitReturn={onSubmitMoveListDisp}
					/>
				</>
			)}
		</>
	);

}

export default StaffMng;